import React from 'react'
import { Icon } from 'antd-mobile'
import TicketItem from '../TicketItem'
import './index.scss'
//工单回复列表
interface Props {
  list: any[]
  count: number
  loadingList: boolean
  openShowModal: any
  isComplete: boolean
  openImageModal: any
}
const ContentList: React.FC<Props> = ({ list, count, loadingList, openShowModal, isComplete, openImageModal }) => {
  return (
    <div className='c-list-wrapper'>
      <div className='header-loading'>
        {loadingList && <Icon type={'loading'} size={'xs'} />}
        {/* {count !== -1 && count <= list.length && <div className='loading-str'>not more ~</div>} */}
      </div>
      {list.map((item, index) => (
        <div className='item-wrapper' key={item._id ? item._id + index : index}>
          <TicketItem itemData={item} isLast={index >= list.length - 1} openShowModal={openShowModal} isComplete={isComplete} openImageModal={openImageModal} />
        </div>
      ))}
    </div>
  )
}

export default ContentList
